import { render, staticRenderFns } from "./SoldArt.vue?vue&type=template&id=cb22f0c6&scoped=true&"
import script from "./SoldArt.vue?vue&type=script&lang=ts&"
export * from "./SoldArt.vue?vue&type=script&lang=ts&"
import style0 from "./SoldArt.vue?vue&type=style&index=0&id=cb22f0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22f0c6",
  null
  
)

export default component.exports